import { cn } from '@lensora/ui'
import * as React from 'react'

import { apiUrl } from '@/lib/api'


interface FaviconImgProps {
  domain: string
  name: string
  size?: number
  className?: string
}

export function FaviconImg({ domain, name, size = 16, className }: FaviconImgProps) {
  const [error, setError] = React.useState(false)
  const initial = (name.replace('www.', '').charAt(0) ?? '?').toUpperCase()

  if (error) {
    return (
      <div
        className={cn('flex shrink-0 items-center justify-center rounded-full bg-brand-accent/10 text-brand-accent', className)}
        style={{ width: size, height: size, fontSize: size * 0.55, fontWeight: 700 }}
      >
        {initial}
      </div>
    )
  }

  return (
    <img
      src={apiUrl(`/api/favicon?domain=${encodeURIComponent(domain)}`)}
      alt={name}
      width={size}
      height={size}
      className={cn('shrink-0 rounded-full object-contain', className)}
      style={{ width: size, height: size }}
      onError={() => setError(true)}
    />
  )
}
